module.exports = __webpack_public_path__ + "img/logo.fbff66d8.png";